import React, { useEffect, useState } from 'react';
import api from '../../seller-apis/api'
import './questions.css';
import PendingQuestions from './PendingQuestion';
import { Route, NavLink, useRouteMatch, Redirect, useHistory } from 'react-router-dom';
import AnsweredQuestions from './AnsweredQuestion';
import QuestionTabs from './QuestionTabs';
import IgnoredQuestions from './IgnoredQuestion';
import { useSelector } from 'react-redux';
import { fetchunansQA,fetchansQA,fetchIgnoredQA } from "../../seller-apis/apidataField";


function QuestionAnswers(props) {
    const history = useHistory();
    const { path, url } = useRouteMatch();
    const [pendingCount, setPendingCount] = useState(0);
    const [answeredCount, setAnsweredCount] = useState(0);
    const [ignoredCount, setIgnoredCount] = useState(0);
    const stateData = useSelector((state) => state);
    
      useEffect(() => {
        if (localStorage.getItem("vendorState") === "partialInactive") {
          history.replace("/home");
          return false;
        }
        if(stateData.ActionReducer.PendingQuestionCount!=null)
        {
        // api.QandA.fetchQA(fetchunansQA({pageNo: "1", size:1, type:"NEW"})).then((res) => {
        //   setPendingCount(res.totalRecords);
        // });
        // setPendingCount(stateData.ActionReducer.PendingQuestionCount);
        api.QandA.QuestionAnswerCount({}).then((res) => {
          // console.log(res?.data.data.records);
          res?.data.data.records.forEach(element => {
            element.questionType=='NEW'&&setPendingCount(element.count);
            element.questionType=='ANSWERED'&&setAnsweredCount(element.count);
            element.questionType=='IGNORED'&&setIgnoredCount(element.count);
            
          });
          // setAnsweredCount(res.totalRecords)
        });
        // api.QandA.fetchQA(fetchunansQA({pageNo: "1", size:1, type:"IGNORED"})).then((res) => {
        //   setIgnoredCount(res.totalRecords)
        // });
    }
      }, [stateData.ActionReducer.PendingQuestionCount]);
    return (
        <>
            <div className=''>

             <QuestionTabs pendingCount={pendingCount} answeredCount={answeredCount} ignoredCount={ignoredCount}  />
                
            </div>
            <div>
                <Route exact path="/questions">
                    <Redirect to={`${path}/pending`} />
                </Route>
                <Route path={`${path}/pending`} component={PendingQuestions} />
                <Route path={`${path}/answered`} component={AnsweredQuestions} />
                <Route path={`${path}/ignored`} component={IgnoredQuestions} />
                
            </div>
        </>
    )




}


export default QuestionAnswers;